import {
  OPEN_URL_MESSAGE,
  notificationTag,
  openGroupPath,
} from "./push-routing";

export const NOTIFICATION_ICON = "/icon-192.png";
export const NOTIFICATION_BADGE = "/icon-monochrome-192.png";

export const parsePushData = (data) => {
  try {
    const message = data?.json();
    if (typeof message?.title !== "string" || message.groupId == null) {
      return null;
    }
    return message;
  } catch (error) {
    return null;
  }
};

export const pendingCount = (notifications = []) =>
  notifications.reduce(
    (sum, notification) => sum + (notification.data?.count || 1),
    0,
  );

const noBadge = () => Promise.resolve();

export const showPushNotification = async (
  registration,
  message,
  { setBadge = noBadge, publicUrl = "" } = {},
) => {
  const tag = message.tag || notificationTag(message.groupId);
  const previous = await registration.getNotifications({ tag });
  await registration.showNotification(message.title, {
    body: message.body,
    tag,
    renotify: true,
    icon: `${publicUrl}${NOTIFICATION_ICON}`,
    badge: `${publicUrl}${NOTIFICATION_BADGE}`,
    data: {
      groupId: message.groupId,
      url: message.url || openGroupPath(message.groupId),
      count: pendingCount(previous) + 1,
    },
  });
  await setBadge(pendingCount(await registration.getNotifications()));
};

export const closeGroupNotifications = async (registration, groupId) => {
  const notifications = await registration.getNotifications({
    tag: notificationTag(groupId),
  });
  notifications.forEach((notification) => notification.close());
};

const byFocus = (a, b) => Number(b.focused) - Number(a.focused);

export const openNotificationTarget = async (clients, url) => {
  const windows = await clients.matchAll({
    type: "window",
    includeUncontrolled: true,
  });
  const [client] = [...windows].sort(byFocus);
  if (!client) return clients.openWindow(url);
  try {
    await client.focus();
  } catch (error) {}
  client.postMessage({ type: OPEN_URL_MESSAGE, url });
  return client;
};

export const resubscribe = async (pushManager, event) => {
  if (event?.newSubscription) return event.newSubscription;
  const applicationServerKey =
    event?.oldSubscription?.options?.applicationServerKey;
  if (!applicationServerKey) return null;
  return pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
};
